module.exports = __webpack_public_path__ + "img/calendesk-logo-square.727de810.jpg";